class FooterAccordion {
  constructor(containerEl) {
    this.container = containerEl;
    if (!this.container) return;
    this.accordionItems = this.container.querySelectorAll(".fac-accordion-item");
    this.boundToggle = this.handleHeaderClick.bind(this);
    this.enabled = false;
    this.init();
    this.bindResize();
  }

  init() {
    // Enable only once per mode (mobile accordion)
    if (window.innerWidth <= 768 && !this.enabled) {
      this.enableMobileMode();
    } else if (window.innerWidth > 768 && this.enabled) {
      this.disableMobileMode();
    } else if (window.innerWidth > 768) {
      // Ensure all content visible on desktop
      this.showAll();
    }
  }

  enableMobileMode() {
    this.enabled = true;
    this.accordionItems.forEach((item) => {
      const header = item.querySelector(".fac-accordion-header");
      if (header && !header.dataset.accordionBound) {
        header.addEventListener("click", this.boundToggle);
        header.dataset.accordionBound = "true";
        // Start collapsed
        this.close(item, false);
      }
    });
  }

  disableMobileMode() {
    this.enabled = false;
    this.accordionItems.forEach((item) => {
      const header = item.querySelector(".fac-accordion-header");
      const content = item.querySelector(".fac-accordion-content");
      if (header && header.dataset.accordionBound) {
        header.removeEventListener("click", this.boundToggle);
        delete header.dataset.accordionBound;
      }
      // reset inline styles so desktop layout controls presentation
      content.style.maxHeight = null;
      content.style.paddingTop = null;
      item.classList.remove("active");
      header?.setAttribute("aria-expanded", "true");
    });
    this.showAll();
  }

  showAll() {
    this.accordionItems.forEach((item) => {
      const content = item.querySelector(".fac-accordion-content");
      const header = item.querySelector(".fac-accordion-header");
      if (content) {
        content.style.maxHeight = "none";
        content.style.paddingTop = "0";
      }
      header?.setAttribute("aria-expanded", "true");
    });
  }

  handleHeaderClick(e) {
    const clickedItem = e.currentTarget.closest(".fac-accordion-item");
    if (!clickedItem) return;
    const isActive = clickedItem.classList.contains("active");
    // Close others
    this.accordionItems.forEach((item) => {
      if (item !== clickedItem) this.close(item);
    });
    if (!isActive) {
      this.open(clickedItem);
    } else {
      this.close(clickedItem);
    }
  }

  open(item) {
    const header = item.querySelector(".fac-accordion-header");
    const content = item.querySelector(".fac-accordion-content");
    if (!content) return;
    item.classList.add("active");
    header?.setAttribute("aria-expanded", "true");
    // Temporarily set maxHeight to scrollHeight for transition
    content.style.maxHeight = content.scrollHeight + "px";
    if (window.innerWidth <= 768) content.style.paddingTop = "15px";
  }

  close(item, animate = true) {
    const header = item.querySelector(".fac-accordion-header");
    const content = item.querySelector(".fac-accordion-content");
    if (!content) return;
    item.classList.remove("active");
    header?.setAttribute("aria-expanded", "false");
    if (!animate) {
      content.style.maxHeight = "0";
    } else {
      content.style.maxHeight = content.scrollHeight + "px"; // set current height
      requestAnimationFrame(() => {
        content.style.maxHeight = "0"; // then collapse
      });
    }
    if (window.innerWidth <= 768) content.style.paddingTop = "0";
  }

  bindResize() {
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.init(), 150);
    });
  }
}

// Initialize accordions (support multiple footer sections if present)
window.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".fac-footer").forEach((footerEl) => {
    new FooterAccordion(footerEl);
  });
});
